@if (overlayActive || !overlay) {
<finxone-web-frontend-form-action-button
  (buttonEvent)="pageAction($event)"
  [btnType]="buttonType"
  [icon]="icon"
  [contentStyle]="contentStyle"
  [iconSize]="iconSize"
  [text]="renderedContent"
  class="d-flex h-100"
  [isAllowedGlobalStyling]="isAllowedGlobalStyling"
  [globalStylingClass]="globalStylingClass + ' buttonText'"
></finxone-web-frontend-form-action-button>
}
